import { render, staticRenderFns } from "./bankForm.vue?vue&type=template&id=dd52263e&scoped=true"
import script from "./bankForm.vue?vue&type=script&lang=js"
export * from "./bankForm.vue?vue&type=script&lang=js"
import style0 from "./bankForm.vue?vue&type=style&index=0&id=dd52263e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd52263e",
  null
  
)

export default component.exports